import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=068ba36c&scoped=true"
import script from "./VideoCall.vue?vue&type=script&lang=js"
export * from "./VideoCall.vue?vue&type=script&lang=js"
import style0 from "./VideoCall.vue?vue&type=style&index=0&id=068ba36c&prod&scoped=true&lang=css"
import style1 from "./VideoCall.vue?vue&type=style&index=1&id=068ba36c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ba36c",
  null
  
)

export default component.exports